module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-10-83874e146b67596d63f8fbdd991555f2.svg";